import type { ModuleRoute } from '../types';
import { TodayPage } from './TodayPage';

/** Pages of this area. Owned by Phase 1 task W4; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/today', element: <TodayPage />, permission: 'today.view' },
  { path: '/today/visits/:id', element: <TodayPage />, permission: 'today.view' },
];
